import { jsx as _jsx } from "react/jsx-runtime";
import Draggable20 from '@carbon/icons-react/es/draggable/20';
import { Button } from '@rocketlane/ui';
import { Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';
import { arrayMove, SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import styled from 'styled-components';
import * as styles from './draggable-table.module.css';
import { Table } from './table';
const SortableItem = SortableElement((props)=>/*#__PURE__*/ _jsx("tr", {
        ...props
    }));
const SortableWrapper = SortableContainer((props)=>/*#__PURE__*/ _jsx("tbody", {
        ...props
    }));
const DraggableHandle = styled(Button)`
  cursor: grab;
`;
const DragHandle = SortableHandle(()=>/*#__PURE__*/ _jsx(Tooltip, {
        title: /*#__PURE__*/ _jsx(FormattedMessage, {
            id: "drag_reorder"
        }),
        children: /*#__PURE__*/ _jsx(DraggableHandle, {
            variant: "ghost",
            type: "button",
            leftIcon: /*#__PURE__*/ _jsx(Draggable20, {
                style: {
                    color: 'var(--icon-secondary)'
                }
            })
        })
    }));
const DragHandleCell = {
    dataIndex: 'sort',
    width: 40,
    className: 'drag-visible',
    render: ()=>/*#__PURE__*/ _jsx(DragHandle, {})
};
export const DraggableTable = ({ rowKey, columns, dataSource = [], onSortChange, ...rest })=>{
    const onSortEnd = ({ oldIndex, newIndex })=>{
        if (oldIndex !== newIndex) {
            const updatedRow = dataSource[oldIndex];
            const newData = arrayMove([
                ...dataSource
            ], oldIndex, newIndex).filter((el)=>!!el);
            onSortChange === null || onSortChange === void 0 ? void 0 : onSortChange(newData, updatedRow, newIndex);
        }
    };
    const DraggableWrapper = (props)=>/*#__PURE__*/ _jsx(SortableWrapper, {
            useDragHandle: true,
            disableAutoscroll: true,
            helperClass: styles.row_dragging,
            onSortEnd: onSortEnd,
            ...props
        });
    const DraggableBodyRow = ({ className, style, ...restProps })=>{
        // function findIndex base on Table rowKey props and should always be a right array index
        const index = dataSource === null || dataSource === void 0 ? void 0 : dataSource.findIndex((x)=>x[rowKey] === restProps['data-row-key']);
        return /*#__PURE__*/ _jsx(SortableItem, {
            index: index,
            ...restProps
        });
    };
    return /*#__PURE__*/ _jsx(Table, {
        ...rest,
        dataSource: dataSource,
        rowKey: rowKey,
        columns: [
            DragHandleCell,
            ...columns !== null && columns !== void 0 ? columns : []
        ],
        components: {
            body: {
                wrapper: DraggableWrapper,
                row: DraggableBodyRow
            }
        }
    });
};
